import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import handleActiveChars from '../utils/handleActiveChars';
import { ClockConfigType } from '../config/letters/config.types';
import { CONFIG_RULES_MAP } from '../config/letters/config.map';
import { SKIN_MAP } from '../config/skins/skins.map';
import { SkinType } from '../config/skins/skins.types';
import { BasicComponentsWrapper } from '../styles/BasicComponentsWrapper';
import ClockRows from './ClockRows';

interface Props {
  configType: ClockConfigType;
  skin: SkinType;
  size: number;
  isVisible: boolean;
  isFullscreen: boolean;
}

const Wrapper = styled.div<{
  $size: number;
  $skin: SkinType;
  $isFullscreen: boolean;
  $isVisible: boolean;
  $configType: ClockConfigType;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  cursor: pointer;

  &:hover {
    scale: ${props => (props.$isFullscreen ? 1 : 1.02)};
  }

  ${props =>
    !props.$isVisible &&
    css`
      opacity: 0;
      scale: 2;
      z-index: -1;

      &:hover {
        scale: 2;
      }
    `};

  ${BasicComponentsWrapper};
  ${props => SKIN_MAP[props.$skin]}
`;

function Clock({ configType, skin, size, isVisible, isFullscreen }: Props) {
  const [activeChars, setActiveChars] = useState<number[]>(
    handleActiveChars(CONFIG_RULES_MAP[configType], configType)
  );

  useEffect(() => {
    setActiveChars(handleActiveChars(CONFIG_RULES_MAP[configType], configType));

    const interval = setInterval(() => {
      setActiveChars(handleActiveChars(CONFIG_RULES_MAP[configType], configType));
    }, 10 * 1000);

    return () => clearInterval(interval);
  }, [configType]);

  return (
    <Wrapper
      $size={size}
      $skin={skin}
      $isVisible={isVisible}
      $isFullscreen={isFullscreen}
      $configType={configType}
    >
      <ClockRows configType={configType} activeChars={activeChars} skin={skin} />
    </Wrapper>
  );
}

export default Clock;
